export var PERMISSION_LEVEL_NO_ACCESS = 0;
export var PERMISSION_LEVEL_READ_ACCESS = 1;
export var PERMISSION_LEVEL_WRITE_ACCESS = 2;
